<template>
  <div>
    <b-row align-h="center">
      <b-col lg="8" class="my-5 check-account">
        <p class="check-account-text">
          {{ $t("permanentlyClosed") }}
        </p>
        <p class="check-account-text">{{ $t("notUndo") }}</p>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col lg="4" class="confirmation-account-content p-5">
        <div
          class="mt-3 confirmation-close-btn"
          ref="btnShow"
          @click="deleteAccount()"
        >
          <modal
            :action="account"
            modalId="modal-delete-account"
            :title="$t('deleteAccountModalTitle')"
            :subTitle="$t('deleteAccountModalSubTitle')"
          ></modal>
          <span class="confirmation-close-btn-label">
            {{ $t("deleteAccount") }}
          </span>
        </div>
        <div class="confirmation-keep-btn mt-3" v-b-modal.modal-keep-account>
          <modal
            :action="account"
            modalId="modal-keep-account"
            :title="$t('keepAccountModalTitle')"
            :subTitle="$t('keepAccountModalSubTitle')"
          ></modal>
          <span class="confirmation-keep-btn-label">
            {{ $t("keepAccount") }}
          </span>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import { pageNavigation } from "../../../mixins/navigation";
import Modal from "../../Modal.vue";

export default {
  name: "DeleteAccountStepTree",
  components: { Modal },
  mixins: [pageNavigation],
  props: {
    token: {
      type: String,
      default: ""
    }
  },
  mounted() {
    const token = localStorage.getItem("token") || null;
    if (!token) {
      window.location = "https://home.trebel.io";
    }
  },
  methods: {
    deleteAccount() {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("userInfo")) || null;
      if (!user || !token) {
        this.$root.$emit("bv::show::modal", "modal-delete-account", "#btnShow");
      } else {
        const data = {
          userId: user.userId,
          status: "confirmation"
        };
        const headers = {
          authorization: `bearer ${token}`
        };
        const url = `${process.env.VUE_APP_HOST_WS}/api/users/account`;
        const options = {
          method: "DELETE",
          headers,
          data,
          url
        };

        axios(options)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("token");
            this.$router.push({ query: { q: "close" } }).catch(() => {});
          })
          .catch(() => {
            window.location = "https://trebel.io/openAppBack";
          });
      }
    }
  }
};
</script>

<style scoped></style>
